module.exports = __webpack_public_path__ + "img/comp-41.cdc28085.png";